import { call, put, select } from "redux-saga/effects";
import { addItemRequest, getItemsRequest, updateItemRequest } from "../../spItems/api";
import { VPORequirementsConditionsListName, VPOStatusQuestionnaireListName } from "src/api/config";
import { setEndQuestionarySuccess, setStatusQuestionarySuccess } from "../actions";
import { getDefaultSaga } from "./getDefaultSaga";
import { updateDefaultSaga } from "src/modules/spItems/sagas/updateDefaultSaga";
import { addDefaultSaga } from "src/modules/spItems/sagas/addDefaultSaga";
import { myTaskActionsListName } from "src/api/config/myTasksActions.config";
import { ContentTypeIdRequirement } from "../api/config";
import { getRequirementString, replaceTitle } from "src/pages/DashboardPage/vpo/utils/data-table";
import { setStatusQuestionarySaga } from "./setStatusQuestionarySaga";

export function* setEndQuestionarySaga({ payload }: any) {
  try {
    if (payload) {

      const { 
        Title,
        ColumnID,
        ColumnTitle,
        // GroupID,
        GroupTitle,
        FactoryID,
        FactoryTitle,
        Status,
        Month,
        Year,
        IsError,
        DirectoryData,
        departments,
        currentUser
      } = payload;

      let GroupID = null;
      if(DirectoryData && DirectoryData.length > 0){
        let group = DirectoryData.filter((item: any) => item.Title == GroupTitle && item.FileRef.indexOf('/Lists/VPOColumns/'+ColumnID) >= 0);
        if(group && group.length > 0){
          GroupID = group[0].ID;
        }
      }

      let isAllCorrectActions = true,
          idStatusQuestionary = false,
          countNo = 0;

      const response_condtions: unknown = yield call<any>(getDefaultSaga, {
        listName: VPORequirementsConditionsListName,
        filters: {
          GroupRequirementFileRef: '*' + ColumnID + '_.000/' + GroupID + '_.000',
          Month: '' + Month,
          Year: '' + Year,
          FactoryID: '' + FactoryID
        },
      })

      // const response_default_requirements_condition: unknown = yield call<any>(getDefaultSaga, {
      //   listName: 'VPODefaultRequirementConditions',
      //   recursiveAll: true,
      //   contentType: 'DefaultRequirementConditions',
      //   filtersType: 'and',
      //   filters: {
      //     FileRef: '*' + ColumnTitle + '/' + GroupTitle + '/',
      //     Condition: 'Lock',
      //   },
      // })

      const response_status: unknown = yield call<any>(getDefaultSaga, {
        listName: VPOStatusQuestionnaireListName,
        filtersType: 'and',
        filters: {
          ColumnID: '' + ColumnID,
          GroupID: '' + GroupID,
          FactoryID: '' + FactoryID,
          Month: '' + Month,
          Year: '' + Year
        },
      });

      if(
        response_status &&
        response_status.items &&
        response_status.items.length > 0
      ){
        response_status.items.map((item: any) => {
          idStatusQuestionary = item.ID;
        })
      }

      const response_requirements: unknown = yield call<any>(getDefaultSaga, {
        listName: 'VPOColumns',
        recursiveAll: true,
        contentType: 'Requirement',
        filtersType: 'and',
        filters: {
          ContentTypeId: '^' + ContentTypeIdRequirement,
          FileRef: '*' + ColumnID + '_.000/' + GroupID + '_.000',
        },
      })
    
      let response_actions: unknown = yield call<any>(getDefaultSaga, {
        listName: 'VPOActions',
        filtersType: 'and',
        filters: {
          ColumnID: '*' + ColumnID,
          GroupID: '*' + GroupID,
          FactoryID: ''+FactoryID
        },
      });

      let ids_actions: (number|string)[] = [];

      let response_inconsistencies: unknown = null;

      let response_tasks : unknown = null;

      if(
        response_actions &&
        response_actions.items &&
        response_actions.items.length > 0
      ){
        response_actions.items.map((item: any) => {
          ids_actions.push(item.ID);
        })

        response_inconsistencies = yield call<any>(getDefaultSaga, {
          listName: 'VPOInconsistencies',
          filters: {
            IdVPOactions: ids_actions
          },
        }) 

        let ids_inconsistencies: (string)[] = []

        if(
          response_inconsistencies &&
          response_inconsistencies.items &&
          response_inconsistencies.items.length > 0
        ){
          response_inconsistencies.items.map((item: any) => {
            ids_inconsistencies.push(item.ID);
          })

          //! Разбивка массива на части по 20 элементов для избежания слишком длинных URL
          const chunkSize = 20;
          const allTaskItems: any[] = [];

          for (let i = 0; i < ids_inconsistencies.length; i += chunkSize) {
            const chunk = ids_inconsistencies.slice(i, i + chunkSize);
            const chunkResponse: any = yield call<any>(getDefaultSaga, {
              listName: myTaskActionsListName,
              filters: {
                ImportantHashTag: chunk.map(item => '*#VPO_' + item)
              },
            });

            if (chunkResponse?.items) {
              allTaskItems.push(...chunkResponse.items);
            }
          }

          response_tasks = { items: allTaskItems };
        }
      }

      if(
        response_requirements &&
        response_requirements.items &&
        response_requirements.items.length > 0
      ){
        response_requirements.items.map((requirement: any) => {
          departments.map((department: any) => {

            let isAnswerNo = true;

            let condition_by_requirement_and_department = response_condtions.items.filter((condition: any) => condition.Requirement.get_lookupId() === requirement.ID && condition.Subdivision.get_lookupId() === department.id);

            // if(
            //   response_default_requirements_condition &&
            //   response_default_requirements_condition.items &&
            //   response_default_requirements_condition.items.length > 0
            // ){
            //   let lock_by_default = response_default_requirements_condition.items.filter((lock: any) => replaceTitle(requirement.FolderName && requirement.FolderName !== '' && requirement.FolderName || requirement.Title).indexOf(getRequirementString(lock.FileRef)?.replaceAll('%25', '%')) >= 0 && lock.Subdivision.get_lookupId() === department.id);

            //   if(
            //     lock_by_default &&
            //     lock_by_default.length > 0
            //   ){
            //     isAnswerNo = false;
            //   }

            // }

            if(
              condition_by_requirement_and_department &&
              condition_by_requirement_and_department.length > 0
            ){
              // isIssetAnswer = true;

              condition_by_requirement_and_department.map((condition_requirement_item: any) => {
                if(
                  condition_requirement_item.Condition.get_lookupId() == 1 ||
                  condition_requirement_item.Condition.get_lookupId() == 3
                ){
                  isAnswerNo = false;
                }
              })

            }

            if(isAnswerNo){
              if(
                response_actions &&
                response_actions.items &&
                response_actions.items.length > 0
              ){
  
                let actions_requirement = response_actions.items.filter((action: any) => action.DemandVPOColumns.get_lookupId() === requirement.ID && action.Subdivision.get_lookupId() === department.id);

                if(
                  actions_requirement &&
                  actions_requirement.length > 0
                ){

                  actions_requirement.map((actions_requirement_item: any) => {

                    let inconsistencies_requirement = [];
                    
                    if(
                      response_inconsistencies &&
                      response_inconsistencies.items &&
                      response_inconsistencies.items.length > 0 
                    ){
    
                      inconsistencies_requirement = response_inconsistencies.items.filter((inconsistency:any) => inconsistency.IdVPOactions === actions_requirement_item.ID);
                    
                    }
    
                    if(
                      inconsistencies_requirement &&
                      inconsistencies_requirement.length > 0
                    ){
    
                      inconsistencies_requirement.map((inconsistencies_requirement_item: any) => {
    
                        let tasks_requirement = [];
    
                        if(
                          response_tasks &&
                          response_tasks.items &&
                          response_tasks.items.length > 0
                        ){
    
                          tasks_requirement = response_tasks.items.filter((task: any) => task.ImportantHashTag.indexOf('#VPO_'+inconsistencies_requirement_item.ID) >= 0);
    
                        }
    
                        if(!tasks_requirement || !tasks_requirement.length){
                          isAllCorrectActions = false;
                        }
    
                      })
    
                    } else {
    
                      isAllCorrectActions = false;
    
                    }
    
                  })

                } else {

                  isAllCorrectActions = false;

                }
  
              } else {

                isAllCorrectActions = false;

              }
            }

          })
        })
      }

      console.log('end status', {
        isAllCorrectActions,
        idStatusQuestionary,
        IsError
      })

      if(
        (isAllCorrectActions && idStatusQuestionary) || 
        (IsError && idStatusQuestionary)
      ){

        yield call<any>(getDefaultSaga, {
          listName: VPOStatusQuestionnaireListName,
          filters: {
            ID: idStatusQuestionary
          },
        });

        yield call<any>(updateDefaultSaga, {
          listName: VPOStatusQuestionnaireListName,
          body: {
            ID: idStatusQuestionary,
            Status: 2,
            IsError: IsError,
            AuthorEnd: currentUser
          }
        })
        
      } else {

        yield call<any>(setStatusQuestionarySaga, { 
          Title,
          ColumnID,
          ColumnTitle,
          GroupID,
          GroupTitle,
          FactoryID,
          FactoryTitle,
          Status: 2,
          Month,
          Year,
          Subdivisions: departments,
          SubdivisionID: '',
          SubdivisionTitle: ''
        })

      }

      if(IsError){
        isAllCorrectActions = true;
      }

      yield put(setEndQuestionarySuccess({
        isAllCorrectActions
      }))

      // return response;

    }
  } catch (error) {
    console.log(error);
  }
}
